import React, { Fragment, Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { getTreeOfContentVisibility } from 'store/treeOfContent/selectors';
import TreeOfContent from 'components/treeOfContent/TreeOfContent';
import { RESULTS_PATH, QUESTION_PATH, LEARNING_OBJECTIVE_PATH } from 'constants/navigation';
import * as actions from 'store/treeOfContent/actions';
import { RootAppState } from 'store/types';
import { getBackground, isMainLogoShown, isAllQuestionsOnOnePage } from 'store/settings/selectors';
import {
  isLearningObjectiveView,
  isQuestionView,
  isResultsView
} from 'components/shell/RouteTransition/viewChecker';
import withNavigation from 'components/hocs/withNavigation';
import { SKIP_TO_CONTENT_IDS } from 'constants/common';
import { getElementIDInViewPort } from 'store/navigation/selectors';
import LearningObjective from '../learningObjective/LearningObjective';
import ResultsPage from '../results/ResultsPage';
import CourseOverviewRouteTransition from './RouteTransition';
import NotFound from '../../../components/notFound/NotFound';
import CourseLayout from '../courseLayout/CourseLayout';

import {
  Container,
  PageContainer,
  ContentContainer,
  CourseOverviewSidebar,
  Blockout
} from './CourseOverview.styled';
import SkipToContent from '../../../components/common/SkipToContent';
import { getPopupVisibility } from '../../../store/popup/selectors';

type CourseOverviewProps = {
  theme: { [key: string]: any };
  isLowResolution: boolean;
  isTreeOfContentExpanded: boolean;
  actions: { [key: string]: any };
  background: { [key: string]: any };
  logoShown: boolean;
  isCourseOnOnePage: boolean;
  match: { [key: string]: any };
  history: { [key: string]: any };
  location: { [key: string]: any };
  elementIdInViewport: string;
  popupExpanded: boolean;
};
export class CourseOverview extends Component<CourseOverviewProps, {}> {
  getElement = (elementId: string) => document.getElementById(elementId);

  getElementHeader = (elementId: string) => {
    const element: HTMLElement | null = this.getElement(elementId);
    if (element) {
      return element.querySelectorAll('h1')[0];
    }
    return null;
  };

  focusContentId = () => {
    const { isCourseOnOnePage = false, location, elementIdInViewport } = this.props;
    if (isQuestionView.test(location.pathname)) {
      if (isCourseOnOnePage) {
        return this.getElementHeader(elementIdInViewport)?.focus();
      }
      return this.getElement(SKIP_TO_CONTENT_IDS.QUESTION_PAGE)?.focus();
    }

    if (isLearningObjectiveView.test(location.pathname)) {
      if (isCourseOnOnePage) {
        return this.getElementHeader(elementIdInViewport)?.focus();
      }
      return this.getElement(SKIP_TO_CONTENT_IDS.LEARNING_OBJECTIVE_PAGE)?.focus();
    }

    if (isResultsView.test(location.pathname)) {
      return this.getElement(SKIP_TO_CONTENT_IDS.RESULT_PAGE)?.focus();
    }

    return this.getElement(SKIP_TO_CONTENT_IDS.QUESTION_PAGE)?.focus();
  };

  render() {
    const {
      isTreeOfContentExpanded,
      background,
      logoShown,
      isCourseOnOnePage = false,
      popupExpanded
    } = this.props;
    return (
      <Fragment>
        {!popupExpanded && <SkipToContent onClick={() => this.focusContentId()} />}
        <CourseOverviewSidebar
          background={background}
          isTreeOfContentExpanded={isTreeOfContentExpanded}
        >
          <TreeOfContent />
        </CourseOverviewSidebar>
        <Blockout
          isTreeOfContentExpanded={isTreeOfContentExpanded}
          onClick={this.props.actions.toggleTreeOfContentVisibility}
          ariaHidden={true}
        />

        <Route
          render={({ location }) => (
            <CourseOverviewRouteTransition
              background={background}
              isTreeOfContentExpanded={isTreeOfContentExpanded}
              location={location}
              isCourseOnOnePage={isCourseOnOnePage}
            >
              <Container>
                <PageContainer>
                  <ContentContainer
                    isTreeOfContentExpanded={isTreeOfContentExpanded}
                    logoShown={logoShown}
                    isCourseOnOnePage={isCourseOnOnePage}
                    dynamicHeight={document.documentElement.clientHeight}
                    isOnOnePageView={
                      isCourseOnOnePage &&
                      (isQuestionView.test(location.pathname) ||
                        isLearningObjectiveView.test(location.pathname))
                    }
                  >
                    <Switch location={location}>
                      <Route
                        exact
                        path={LEARNING_OBJECTIVE_PATH}
                        component={isCourseOnOnePage ? CourseLayout : LearningObjective}
                      />
                      <Route exact path={QUESTION_PATH} component={CourseLayout} />

                      <Route exact path={RESULTS_PATH} component={ResultsPage} />
                      <Route exact path="*" component={NotFound} />
                    </Switch>
                  </ContentContainer>
                </PageContainer>
              </Container>
            </CourseOverviewRouteTransition>
          )}
        />
      </Fragment>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

function mapStateToProps(state: RootAppState) {
  return {
    isLowResolution: state.app.isLowResolution,
    isTreeOfContentExpanded: getTreeOfContentVisibility(state),
    background: getBackground(state),
    logoShown: isMainLogoShown(state),
    isCourseOnOnePage: isAllQuestionsOnOnePage(state),
    elementIdInViewport: getElementIDInViewPort(state),
    popupExpanded: getPopupVisibility(state)
  };
}
export default withRouter(
  withNavigation(connect(mapStateToProps, mapDispatchToProps)(CourseOverview))
);
